import { IAbsenceTypeGroup } from "src/utils/Company/Absences/transformAbsenceTypesToGroupedLists";
import { GROUP_ID_PREFIX } from "./absenceGroupOrderUtils";

export interface IAbsenceGroupTreeNode {
  id: string;
  label: string;
  color?: string;
  children?: IAbsenceGroupTreeNode[];
}

const transformGroupedAbsenceTypesToTreeItems = (
  groups: IAbsenceTypeGroup[]
): IAbsenceGroupTreeNode[] =>
  groups.map((group) => {
    const parents = group.absenceTypes.filter(
      (t) => !t.billingCycleConfiguration?.parentAbsenceTypeId
    );
    const childrenMap = new Map<string, typeof group.absenceTypes>();
    group.absenceTypes.forEach((t) => {
      const parentId = t.billingCycleConfiguration?.parentAbsenceTypeId;
      if (parentId) {
        if (!childrenMap.has(parentId)) childrenMap.set(parentId, []);
        childrenMap.get(parentId)!.push(t);
      }
    });

    return {
      id: `${GROUP_ID_PREFIX}${group.groupId}`,
      label: group.groupName,
      color: group.groupColor,
      children: parents.map((parent) => ({
        id: parent.id,
        label: parent.name,
        children: (childrenMap.get(parent.id) ?? []).map((child) => ({
          id: child.id,
          label: child.name,
        })),
      })),
    };
  });

export default transformGroupedAbsenceTypesToTreeItems;
